<div class="flex" style="height: 100vh; flex-direction: column;">
  <div style="padding-top: 15px; padding-left: 20px; padding-right: 20px; padding-bottom: 15px; border-bottom: 1px solid #eef1f0 ;">
    <app-header></app-header>
  </div>

  <div class="align-content-center align-self-center flex-1 justify-content-center forbidden" style="padding-left: 20px; padding-right: 20px;">
    <div class="forbidden-code">
      <h1>{{ code }}</h1>
    </div>

    <h2>{{ title }}</h2>
    <p>{{ message }}</p>

    <button type="button" (click)="goBack()">Go Back</button>
  </div>
</div>


